import { useEffect, useRef, useState } from "react";

const easeInOutCubic = (t: number) =>
  t < 0.5 ? 4 * t ** 3 : 1 - (-2 * t + 2) ** 3 / 2;

const prefersReducedMotion = () =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// Eases the returned number towards the target; reduced motion jumps straight to it
export const useTween = (target: number, duration = 450) => {
  const [value, setValue] = useState(target);
  const valueRef = useRef(target);

  useEffect(() => {
    const from = valueRef.current;
    if (from === target) return;

    const start = performance.now();
    const length = prefersReducedMotion() ? 0 : duration;

    let frame = requestAnimationFrame(function step(now) {
      const progress =
        length === 0 ? 1 : Math.min(1, Math.max(0, (now - start) / length));

      valueRef.current = from + (target - from) * easeInOutCubic(progress);
      setValue(valueRef.current);

      if (progress < 1) frame = requestAnimationFrame(step);
    });

    return () => cancelAnimationFrame(frame);
  }, [target, duration]);

  return value;
};
